import { useContext } from 'react';
import { DebugContext, DebugContextProps } from 'src/providers/DebugContextProvider';

export const useDebugContext = (): DebugContextProps => {
  return useContext(DebugContext);
};
